import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=dbe72f40&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbe72f40')) {
      api.createRecord('dbe72f40', component.options)
    } else {
      api.reload('dbe72f40', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=dbe72f40&", function () {
      api.rerender('dbe72f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24Y8rfSZK1KVJ/JS/offershelp.vue"
export default component.exports